//--002
export const docRouter=[
    {
        path: '/home',
        component: () => import(/* webpackChunkName: 'home' */ '@/pages/home/home'),
        children: [
            {
                path: '/homeIndex',
                name: 'homeIndex',
                component: () => import(/* webpackChunkName: 'home' */ '@/pages/home/index'),
            },
            {
                path: '/person',
                name:'person',
                component: () => import(/* webpackChunkName: 'personal' */ '@/pages/personal/person'),
            },
            {//账号管理
                path: '/account',
                name:'account',
                meta: {
                    requiresAuth: true
                },
                component: () => import(/* webpackChunkName: 'personal' */ '@/pages/personal/account'),
            },
            {//签约用户
                path: '/listSign',
                name: 'listSign',
                component: () => import(/* webpackChunkName: 'sign_patient' */ '@/pages/sign_patient/listSign'),
            },
            {//用户资料
                path: '/detailRecord',
                name: 'detailRecord',
                component: () => import(/* webpackChunkName: 'record' */ '@/pages/record/detailRecord'),
            },
            {//健康监控
                path: '/monitoring',
                name: 'monitoring',
                component: () => import(/* webpackChunkName: 'record' */ '@/pages/health/monitoring'),
            },
            {//绑定设备
                path: '/listDevice',
                name: 'listDevice',
                component: () => import(/* webpackChunkName: 'record' */ '@/pages/device/listDevice'),
            },
            {//联系用户
                path: '/detailPatient',
                name: 'detailPatient',
                component: () => import(/* webpackChunkName: 'sign_patient' */ '@/pages/sign_patient/detailPatient'),
            },
            {//智能随访
            path: '/intelligenceFollow',
            name: 'intelligenceFollow',
            component: () => import(/* webpackChunkName: 'intelligenceFollow' */ '@/pages/sign_patient/intelligenceFollow'),
            },
            {//异常测量数据
                path: '/exception',
                name: 'exception',
                component: () => import(/* webpackChunkName: 'sign_patient' */ '@/pages/sign_patient/abnormalData'),
            },
            {//未填写基本信息明细
                path: '/notFilled',
                name: 'notFilled',
                component: () => import(/* webpackChunkName: 'sign_patient' */ '@/pages/sign_patient/notFilled'),
            },
            // {//
            //     path: '/qrCode',
            //     name: 'qrCode',
            //     component: () => import(/* webpackChunkName: 'sign_patient' */ '@/pages/sign_patient/qrCode'),
            // },
            {//档案
                path: '/dangAn',
                name: 'dangAn',
                component: () => import(/* webpackChunkName: 'sign_patient' */ '@/pages/sign_patient/dangAn'),
            },
            
        ]
    }
]
//--001
export const patientRouter=[
    {
        path: '/home',
        component: () => import(/* webpackChunkName: 'home' */ '@/pages/home/home'),
        children: [
            {
                path: '/homeIndex',
                name: 'homeIndex',
                component: () => import(/* webpackChunkName: 'home' */ '@/pages/home/index'),
            },
            {
                path: '/person',
                name:'person',
                component: () => import(/* webpackChunkName: 'personal' */ '@/pages/personal/person'),
            },
            {//账号管理
                path: '/account',
                name:'account',
                meta: {
                    requiresAuth: true
                },
                component: () => import(/* webpackChunkName: 'personal' */ '@/pages/personal/account'),
            },
            {//家庭医生
                path: '/listDoctor',
                name: 'listDoctor',
                component: () => import(/* webpackChunkName: 'doctor' */ '@/pages/doctor/listDoctor'),
            },
            {//我的家人
                path: '/listFamily',
                name: 'listFamily',
                component: () => import(/* webpackChunkName: 'my_family' */ '@/pages/my_family/listFamily'),
            },
            {//用户资料
                path: '/detailRecord',
                name: 'detailRecord',
                component: () => import(/* webpackChunkName: 'record' */ '@/pages/record/detailRecord'),
            },
            {//健康监控
                path: '/monitoring',
                name: 'monitoring',
                component: () => import(/* webpackChunkName: 'health' */ '@/pages/health/monitoring'),
            },
            {//联系医生
                path: '/detailDoctor',
                name: 'detailDoctor',
                component: () => import(/* webpackChunkName: 'doctor' */ '@/pages/doctor/detailDoctor'),
            },
            {//绑定设备
                path: '/listDevice',
                name: 'listDevice',
                component: () => import(/* webpackChunkName: 'device' */ '@/pages/device/listDevice'),
            },
        ]
    }
]
//监护人-003
export const guardianRouter=[
    {
        path: '/home',
        component: () => import(/* webpackChunkName: 'home' */ '@/pages/home/home'),
        children: [
            {
                path: '/homeIndex',
                name: 'homeIndex',
                component: () => import(/* webpackChunkName: 'home' */ '@/pages/home/index'),
            },
            {
                path: '/person',
                name:'person',
                component: () => import(/* webpackChunkName: 'personal' */ '@/pages/personal/person'),
            },
            {//账号管理
                path: '/account',
                name:'account',
                meta: {
                    requiresAuth: true
                },
                component: () => import(/* webpackChunkName: 'personal' */ '@/pages/personal/account'),
            },
            {//家庭医生
                path: '/listDoctor',
                name: 'listDoctor',
                component: () => import(/* webpackChunkName: 'doctor' */ '@/pages/doctor/listDoctor'),
            },
            {//我的家人
                path: '/listFamily',
                name: 'listFamily',
                component: () => import(/* webpackChunkName: 'my_family' */ '@/pages/my_family/listFamily'),
            },
            {//用户资料
                path: '/detailRecord',
                name: 'detailRecord',
                component: () => import(/* webpackChunkName: 'record' */ '@/pages/record/detailRecord'),
            },
            {//健康监控
                path: '/monitoring',
                name: 'monitoring',
                component: () => import(/* webpackChunkName: 'health' */ '@/pages/health/monitoring'),
            },
            {//联系医生
                path: '/detailDoctor',
                name: 'detailDoctor',
                component: () => import(/* webpackChunkName: 'doctor' */ '@/pages/doctor/detailDoctor'),
            },
            {//绑定设备
                path: '/listDevice',
                name: 'listDevice',
                component: () => import(/* webpackChunkName: 'device' */ '@/pages/device/listDevice'),
            },
        ]
    }
]
//库房-销售-004
export const salesRouter=[
    
    {
        path: '/admin',
        name: 'admin',
        component: () => import(/* webpackChunkName: 'admin' */ '@/pages/admin/home'),
        redirect: '/admin/equipment',
        children: [
            {//绑定用户
                path: '/admin/bound',
                name: 'adminBound',
                component: () => import(/* webpackChunkName: 'sales' */ '@/pages/admin/sales/bound'),
            },
            {//未绑定用户
                path: '/admin/unbound',
                name: 'adminUnBound',
                component: () => import(/* webpackChunkName: 'sales' */ '@/pages/admin/sales/unbound'),
            },
            {//档案资料
                path: '/admin/patientRecord',
                name: 'patientRecord',
                component: () => import(/* webpackChunkName: 'admin' */ '@/pages/admin/patientRecord'),
            },
            {//健康监控
                path: '/admin/patientHealth',
                name: 'patientHealth',
                component: () => import(/* webpackChunkName: 'admin' */ '@/pages/admin/patientHealth'),
            },
            {//随访记录
                path: '/admin/followUp',
                name: 'adminFollow',
                component: () => import(/* webpackChunkName: 'sales' */ '@/pages/admin/sales/followUp'),
            },
        ]
    }
]
//库房-库房-005
export const warehouse=[
    {
        path: '/admin',
        name: 'admin',
        component: () => import(/* webpackChunkName: 'admin' */ '@/pages/admin/home'),
        redirect: '/admin/equipment',
        children: [
            {//设备录入
                path: '/admin/device',
                name: 'adminDevice',
                component: () => import(/* webpackChunkName: 'warehouse' */ '@/pages/admin/warehouse/device'),
            },
            {//用户与设备
                path: '/admin/equipment',
                name: 'adminEquipment',
                component: () => import(/* webpackChunkName: 'warehouse' */ '@/pages/admin/warehouse/equipment'),
            },
        ]
    }
]


// WEBPACK FOOTER //
// ./src/router/staticRouter.js